import { FaTriangleExclamation } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { Flex } from "../../../../../styled-system/jsx";

const MultiMarketplaceAdWarning = () => {
  const { t } = useTranslation(["advertising"]);
  return (
    <Flex
      className={css({
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "xxlarge",
        paddingBottom: "xlarge",
        borderTop: "1px solid gray",
        margin: "small",
      })}
    >
      <p>
        <FaTriangleExclamation />{" "}
        {t(
          ($) =>
            $.advertising[
              "This media plan is part of a multi-marketplace campaign. Trellis currently supports this campaign type for reporting only."
            ],
        )}
      </p>
    </Flex>
  );
};

export { MultiMarketplaceAdWarning };
